@import 'styles/mixins';
@import 'styles/variables';

.container {
  @include transition();
  --review-template-columns-template: 1fr 74px;
  margin-top: 20px;
}

.withLastEditor {
  --review-template-columns-template: 1fr 180px 74px;
}

.row {
  @include md-regular;
  color: var(--neutral-90);
  display: grid;
  grid-template-columns: var(--review-template-columns-template);
  border-bottom: 1px solid var(--neutral-5);
  height: 40px;
  align-items: center;
}

.interactiveRow {
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out, visibility 0s;
  -webkit-transition: all 0.2s ease-in-out, visibility 0s;

  &.hovered {
    background: var(--neutral-5);
  }

  &.pressed {
    background: var(--neutral-10);
  }

  &.focused {
    box-shadow: inset 0 0 0 2px rgba(var(--neutral-50), 0.1);
  }
}

.headers {
  @include sm-regular;
  color: var(--neutral-30);
}

.headers {
  display: grid;
  grid-template-columns: var(--review-template-columns-template);
  border-bottom: 1px solid var(--neutral-5);
  height: 24px;
  align-items: center;
}

.timesUsed,
.lastEditor {
  @include md-regular;
  color: var(--neutral-50);
}

.lastEditor {
  display: flex;
  gap: 6px;
  align-items: center;

  span {
    @include line-clamp();
  }
}

.allTemplatesBtn {
  margin-top: 6px;
}

.templateNameButton {
  @include md-regular;

  width: 100%;
  justify-content: flex-start;
}

.flex {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  padding-right: 24px;
  margin-left: 4px;

  svg path {
    fill: var(--neutral-40);
  }
}

.skeleton {
  .row {
    gap: 8px;
    border-bottom: none;
  }

  .icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .name {
    width: 100%;
    height: 20px;
  }

  .timesUsed {
    height: 20px;
    width: 100%;
  }
}

.coldState {
  @include md-regular;
  color: var(--neutral-90);
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: center;

  .icon {
    width: 44px;
    height: 44px;
    background-color: var(--action-10);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--action-50);
  }
}

.coldStateTitle {
  @include xl-regular;
  color: var(--neutral-40);
}

.coldStateText {
  @include md-regular;
  color: var(--neutral-40);
  width: 360px;
  text-align: center;
}

.actions {
  display: flex;
  gap: 2px;
}

.iconButton,
.iconButton path {
  color: var(--neutral-40) !important;
  fill: var(--neutral-40) !important;
}

.visible {
  visibility: visible;
}

.hidden {
  visibility: hidden;
}

.confirmationText {
  @include md-semibold;
  color: var(--neutral-90);
  margin: 16px;
  text-align: center;
}

.confirmationButtons {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px;
  gap: 8px;
}

.templateName {
  color: var(--neutral-90);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.topButtons {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.portalHeaders {
  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%;
  height: 40px;
}
